export default "__VITE_ASSET__gcAeE3yX__"